import { PageController } from '@client/components/_core/layout/PageController';
import { PaymentOverlay } from '@client/components/claims/financials/payment-approval/PaymentOverlay';
import { ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';

/**
 * CUR-2673: a payment raised for approval, on the claim's Financials tab. The person it waits on
 * decides it here; the raiser withdraws it or marks it paid; anyone else who may see it sees where it
 * is, without the buttons.
 */
export const Route = createFileRoute('/console/$orgId/claims/details/$id/financials/payments/$compensationId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Payment',
        },
        // Hidden with the rest of payment approval; the server answers NOT_FOUND while it is off.
        featureFlag: ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG,
    },
    params: {
        parse({ compensationId }) {
            return {
                compensationId: BigInt(compensationId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { id: claimId, compensationId } = Route.useParams();
    return (
        <PageController route={Route}>
            <PaymentOverlay claimId={claimId} compensationId={compensationId} />
        </PageController>
    );
}
